<template>
  <!-- {{ theme }} -->
  <template v-if="showHub == true">
    <header-short v-if="theme == 'blackdiamond'" :inIframe="inIframe" :isShort="isShort" :searchQuery="searchQuery" :lib_id="library_key" :showSearch="showSearch" @searchQuery="searchData" />
    <HeaderShortCrispAzure v-if="theme == 'crispazure'" :inIframe="inIframe" :isShort="isShort" :lib_id="library_key" :searchQuery="searchQuery" :showSearch="showSearch" @searchQuery="searchData" />
    <HeaderShortBlueSky v-if="theme == 'bluesky'" :inIframe="inIframe" :isShort="isShort" :lib_id="library_key" :searchQuery="searchQuery" :showSearch="showSearch" @searchQuery="searchData" />
    <HeaderShortAstroFusion v-if="theme == 'astrofusion'" :inIframe="inIframe" :isShort="isShort" :lib_id="library_key" :searchQuery="searchQuery" :showSearch="showSearch" @searchQuery="searchData" />
    <router-view :theme="theme" :subscription_plan="subscription_plan" :articleTipText="articleTipText" :articleTipHeading="articleTipHeading" :articleTipsstatus="articleTipsstatus" @searchQuery="searchData" :searchQuery="searchQuery" :domain="$store.state.library_domain"></router-view>
    <FooterHub v-if="!inIframe" />
  </template>
  <template v-if="showHub == false">
    <div class="text-center my-5 text-dark">
      <i class="fa fa-exclamation-triangle h1 mb-3 text-warning" aria-hidden="true"></i>
      <div class="h5 w-lg-75 w-100 mx-auto px-2">It looks like your subscription is no longer active. Please reach out to the team in Slack if you feel that this is a mistake or if you want to re-activate your account.</div>
    </div>
  </template>
</template>
<script>
import HeaderShort from '@/components/custom/front/HeaderShort.vue';
import HeaderShortCrispAzure from '@/components/custom/front/HeaderShortCrispAzure.vue';
import HeaderShortBlueSky from '@/components/custom/front/HeaderShortBlueSky.vue';
import HeaderShortAstroFusion from '@/components/custom/front/HeaderShortAstroFusion.vue';
import FooterHub from './FooterHub.vue';

import getCustomCss from '@/composables/getCustomCss';
import getIntegrations from '@/composables/getIntegrations';
import getGoogleTranslateIntegration from '@/composables/getGoogleTranslateIntegration';
import { projectFirestore } from '@/firebase/config';
import Api from '@/api/Api';
const axios = require('axios');
export default {
  name: 'Frontend',
  components: {
    HeaderShort,
    FooterHub,
    HeaderShortCrispAzure,
    HeaderShortBlueSky,
    HeaderShortAstroFusion,
  },
  data() {
    return {
      searchQuery: '',
      isShort: false,
      showSearch: true,
      parentURL: '',
      library_key: '',
      showHub: null,
      theme: '',
      articleTipHeading: '',
      articleTipText: '',
      articleTipsstatus: '',
      subscription_plan: '',
    };
  },
  mounted() {
    if (this.$route.params.library_key) {
      this.initData(this.$route.params.library_key);
    } else {
      if (this.$route?.query?.debugging == 'on') {
        let hostname = new URL(window.location.href).hostname;
        console.log('hostname ', hostname);
      }
      projectFirestore
        .collection('SupportLibraries')
        .where('custom_subDomain', '==', new URL(window.location.href).hostname)
        .get()
        .then(async snap => {
          if (!snap.empty) {
            if (this.$route?.query?.debugging == 'on') {
              console.log('snap.docs[0].id ', snap.docs[0].id);
            }
            await this.initData(snap.docs[0].id);
          } else {
            this.$router.push({ name: 'Login' });
          }
        });
    }
    this.searchQuery = this.$route?.query?.search ? decodeURIComponent(this.$route.query.search) : '';
  },
  methods: {
    searchData($event) {
      if ($event.trim() !== '') {
        this.$router.push({ name: this.$route.name, query: { ...this.$route.query, search: encodeURIComponent($event) } });
      } else {
        let query = { ...this.$route.query };
        if (query.search) {
          delete query.search;
        }
        this.$router.push({ name: this.$route.name, query: query });
      }
    },
    async getAgencyDetails(key) {
      await Api.getAgencyDetailsUnauth(key, { rt: 'public' })
        .then(res => {
          if (this.$route?.query?.debugging == 'on') {
            console.log(' res?.data ', res?.data);
          }
          if (res?.data?.subscription) {
            this.subscription_plan = res?.data?.subscription;
            if (this.$route?.query?.debugging == 'on') {
              console.log(' this.subscription_plan = ', this.subscription_plan);
            }
          }
        })
        .catch(err => {
          this.$store.dispatch('printLog', { text: 'error getting agency details :- ', log: err, type: 'error' });
        });
    },
    async initData(key) {
      document.body.setAttribute('mid', key);
      const { isCustomCss } = getCustomCss();
      this.library_key = key;

      await this.getAgencyDetails(key);

      await projectFirestore
        .collection('SupportLibraries')
        .doc(key)
        .get()
        .then(res => {
          if (res.exists && res.data()?.parent_lib_id) {
            const parent_lib_id = res.data()?.parent_lib_id ? res.data()?.parent_lib_id : null;
            this.$store.state.parent_lib_id = parent_lib_id;
            this.$store.state.library_domain = res.data()?.library_domain ? res.data()?.library_domain : '';
            this.$store.state.library_refkey = res.data()?.library_refkey ? res.data()?.library_refkey : '';
            this.$store.state.siteCopyRight = res.data()?.settings?.settings?.siteCopyRight ? res.data()?.settings?.settings?.siteCopyRight : '';
            localStorage.setItem('parent_lib_id', parent_lib_id);
            axios.get(`https://auth.locationapi.co/resources1?k=${res.data().library_refkey}`).then(resp => {
              if (resp?.data?.e == undefined || resp?.data?.e == 0) {
                this.showHub = false;
              } else {
                this.showHub = true;
                this.initialize();
              }
            });
          } else {
            this.showHub = true;
            this.initialize();
          }
          if (res?.data()?.settings?.settings?.companyName) {
            this.$store.state.frontendCompanyName = res.data().settings.settings.companyName;
          }
          if (res.data()?.selectedTheme) {
            this.theme = res.data()?.selectedTheme;
            if (this.theme === 'bluesky') {
              document.body.classList.add('blueskype-bg');
            }
            if (this.theme === 'astrofusion') {
              document.body.classList.add('astrofusion-bg');
            }
          } else {
            this.theme = process.env.VUE_APP_DEFAULT_THEME;
          }
          if (res.data()?.articleTipHeading) {
            this.articleTipHeading = res.data().articleTipHeading;
          }
          if (res.data()?.articleTipText) {
            this.articleTipText = res.data().articleTipText;
          }
          if (res.data()?.articleTipsstatus) {
            this.articleTipsstatus = res.data().articleTipsstatus;
          }
        });
      await isCustomCss(this.library_key, 'theme');
    },

    initialize() {
      this.parentURL = this.$route.query.parentURL ? this.$route.query.parentURL : document.referrer;
      const { isGoogleTranslateIntegrations } = getGoogleTranslateIntegration();
      const { isIntegrations } = getIntegrations();
      this.parentURL = this.$route.query.parentURL ? this.$route.query.parentURL : document.referrer;
      if (['HubHome', 'HubHome2', 'TechnoHub', 'TechnoSearch'].includes(this.$route.name)) {
        this.isShort = false;
      } else {
        this.isShort = true;
      }

      if (['FrontendNews', 'FrontendNewsFlash', 'HubCourses', 'HubCourses2', 'HubCourseDetails', 'HubCourseDetails2'].includes(this.$route.name)) {
        this.showSearch = false;
      } else {
        this.showSearch = true;
      }

      if (this.$route.params.library_key) {
        isIntegrations(this.$route.params.library_key, 'theme');
        isGoogleTranslateIntegrations(this.$route.params.library_key);
      } else {
        projectFirestore
          .collection('SupportLibraries')
          .where('custom_subDomain', '==', new URL(window.location.href).hostname)
          .get()
          .then(async snap => {
            if (!snap.empty) {
              isIntegrations(snap.docs[0].id, 'theme');
              isGoogleTranslateIntegrations(snap.docs[0].id);
            } else {
              this.$router.push({ name: 'Login' });
            }
          });
      }

      projectFirestore
        .collection('SupportLibraries')
        .doc(this.$route.params.library_key)
        .get()
        .then(doc => {
          if (doc.exists) {
            // console.log('doc?.data()?.settings', doc?.data()?.settings)
            if (doc?.data()?.settings?.widget?.theme) {
              if (doc?.data()?.settings?.widget?.theme == 'compact') {
                document.body.classList.add(`compact-widget`);
                document.body.classList.add(`compact-toolbar`);
              } else {
                document.body.classList.remove(`compact-toolbar`);
              }
            }
            if (doc.data()?.chatIntegrations?.enable == true) {
              if (window.LiveChatWidget) {
                LiveChatWidget.init();
                // LiveChatWidget.call("maximize");
                LiveChatWidget.on('visibility_changed', event => {
                  // console.log('max', event)
                  if (event.visibility == 'maximized') {
                    LiveChatWidget.call('set_session_variables', {
                      'Started on': this.parentURL,
                    });
                  }
                });
              }
            }
          }
        });
      window.addEventListener(
        'message',
        function (e) {
          if (e.data.event == 'addCompactClass') {
            document.body.classList.add(`compact-widget`);
          } else if (e.data.event == 'removeCompactClass') {
            document.body.classList.remove(`compact-widget`);
          }
        },
        false,
      );
    },
  },
  watch: {
    $route() {
      this.parentURL = this.$route.query.parentURL ? this.$route.query.parentURL : document.referrer;
      // console.log('this.$route', this.$route)
      if (['HubHome', 'HubHome2', 'TechnoHub', 'TechnoSearch'].includes(this.$route.name)) {
        this.isShort = false;
      } else {
        this.isShort = true;
      }

      if (['FrontendNews', 'FrontendNewsFlash', 'HubCourses', 'HubCourses2', 'HubCourseDetails', 'HubCourseDetails2'].includes(this.$route.name)) {
        this.showSearch = false;
      } else {
        this.showSearch = true;
      }

      window.scrollTo(0, 0);

      this.searchQuery = this.$route?.query?.search ? decodeURIComponent(this.$route.query.search) : '';

      // let keyword = this.$route.query.keyword
      // console.log('keyword', keyword)
      // if (keyword) {
      //     this.searchQuery = keyword
      // } else {
      //     this.searchQuery = ''
      // }
    },
  },
  computed: {
    inIframe() {
      return window.self !== window.top;
    },
  },
};
</script>

<style>
::-webkit-scrollbar {
  display: none !important;
}

/* Hide scrollbar for Firefox */
* {
  scrollbar-width: none !important;
  scrollbar-color: transparent transparent;
}

/* Hide scrollbar for IE, Edge (older versions) */
* {
  -ms-overflow-style: none !important;
}
.subscription-note {
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}

body.g-translate {
  top: 0 !important;
}

body.g-translate #modal_gtranslate {
  outline: none !important;
  /* position: absolute !important; */
  top: -8px !important;
  left: 0 !important;
  right: 0 !important;
  /* display: flex !important; */
  align-items: center !important;
  justify-content: center !important;
  z-index: 99 !important;
  overflow: hidden !important;
  width: 160px !important;
  left: calc(50% - 80px) !important;
}

body.g-translate .skiptranslate:not(body.g-translate #modal_gtranslate .skiptranslate, body.g-translate #goog-gt-tt.skiptranslate) {
  outline: none;
  width: 0px !important;
  height: 0px !important;
  position: absolute !important;
  z-index: 99999 !important;
  overflow: hidden !important;
  box-shadow: none !important;
  left: -50px !important;
  right: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 101 !important;
  margin: auto !important;
}

body.g-translate iframe.skiptranslate {
  position: absolute !important;
  box-shadow: none !important;
  border-radius: 50% !important;
  border: 0px solid #000 !important;
  margin-left: -30px !important;
}

body.g-translate #modal_gtranslate .skiptranslate {
  outline: none !important;
}

body.g-translate #modal_gtranslate .skiptranslate.goog-te-gadget {
  font-size: 0px !important;
}

body.g-translate #goog-gt-tt,
body.g-translate #goog-gt-tt > div {
  display: none !important;
  width: 0px !important;
  height: 0px !important;
  font: 0px !important;
  opacity: 0 !important;
}

body.g-translate #modal_gtranslate .skiptranslate.goog-te-gadget span,
body.g-translate #modal_gtranslate .skiptranslate.goog-te-gadget a {
  font-size: 0px !important;
  display: none !important;
}

body.g-translate #modal_gtranslate select.goog-te-combo {
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 5px !important;
  background-color: var(--primaryColor) !important;
  padding: 3px 10px !important;
  padding-top: 5px !important;
  color: #fff !important;
  box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.05) !important;
  max-width: 145px !important;
}

/* body.g-translate #modal_gtranslate select.goog-te-combo {
    appearance: none !important; 
    -webkit-appearance: none !important; 
}

 body.g-translate #modal_gtranslate select.goog-te-combo::after
 {
    font-family: "FontAwesome" !important;
    content: '\f054';
    position: absolute !important;
    top: 50% !important;
    right: 10px !important; 
    transform: translateY(-50%) !important;
    pointer-events: none !important;
    font-family: fontawesome !important;
}
body.g-translate #modal_gtranslate select.goog-te-combo:hover,
body.g-translate #modal_gtranslate select.goog-te-combo:focus{
    outline: none;
}  */

body.g-translate header .headcol {
  padding-top: 22px !important;
}

body.g-translate header .headcol {
  padding-top: 22px !important;
}

body.g-translate .mt75 {
  margin-top: 97px !important;
}
.p-b-322 {
  padding-bottom: 322px !important;
}

/* .goog-te-gadget {color: transparent!important; height: 30px!important; text-align: right;}
.goog-te-gadget a {font-size:0px !important; display:none !important;} */
</style>
